<template>
  <div class="select-filters">
    <div class="form-field">
      <v-autocomplete
        v-model="selectedValue"
        :label="label"
        density="compact"
        variant="outlined"
        :items="items"
        :item-title="itemTitle"
        :item-value="itemValue"
        @update:model-value="updateFilterValue"
      ></v-autocomplete>
    </div>
  </div>
</template>

<script>
export default {
  name: "GenericFilter",
  props: {
    label: {
      type: String,
      default: "Select",
    },
    items: {
      type: Array,
      required: true,
    },
    itemTitle: {
      type: String,
      default: "name", // Default key for item titles
    },
    itemValue: {
      type: String,
      default: "id", // Default key for item values
    },
    filterKey: {
      type: String,
      required: true, // Specifies the query key to update
    },
  },
  data() {
    return {
      selectedValue: this.$route.query[this.filterKey] || null,
    };
  },
  methods: {
    updateFilterValue(value) {
      let query = {
        ...this.$route.query,
        [this.filterKey]: value,
      };

      if (!value) {
        delete query[this.filterKey];
      }

      this.$router.push({ query: query });
    },
  },
};
</script>

<style scoped>
.select-filters {
  width: 150px;
  height: 100%;
  margin-left: 20px;
}

@media (max-width: 768px) {
  .select-filters {
    margin-left: unset;
  }
}
</style>
